var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/base', 'model/ledger-account-category-order'], function($, core, BaseCollection, LedgerAccountCategoryOrderModel) {
  var LedgerAccountCategoryOrderCollection;
  return LedgerAccountCategoryOrderCollection = (function(_super) {

    __extends(LedgerAccountCategoryOrderCollection, _super);

    function LedgerAccountCategoryOrderCollection() {
      LedgerAccountCategoryOrderCollection.__super__.constructor.apply(this, arguments);
    }

    LedgerAccountCategoryOrderCollection.prototype.initialize = function(models, options) {
      if (options == null) {
        options = {};
      }
      return this.clientId = options.clientId ? options.clientId : core.getCurrentClientId();
    };

    LedgerAccountCategoryOrderCollection.prototype.path = function() {
      return core.getConfig().apiPrefix + 'ledgeraccountcategory.json/order/client/' + this.clientId;
    };

    LedgerAccountCategoryOrderCollection.prototype.model = LedgerAccountCategoryOrderModel;

    return LedgerAccountCategoryOrderCollection;

  })(BaseCollection);
});
